import { render, staticRenderFns } from "./ImgSlider.vue?vue&type=template&id=68bc710e"
import script from "./ImgSlider.vue?vue&type=script&lang=js"
export * from "./ImgSlider.vue?vue&type=script&lang=js"
import style0 from "./ImgSlider.vue?vue&type=style&index=0&id=68bc710e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports